import {
    CLIENT_CANDIDATE_LIST_REQUEST,
    CLIENT_CANDIDATE_LIST_SUCCESS,
    CLIENT_CANDIDATE_LIST_FAIL,
  } from "../constants/AuthConstant";


  const initialState = {
    result: null,
    loading: null,
    error: null
};


const ClientCandidateListReducer = (state = initialState, action) => {
    switch (action.type) {
        case CLIENT_CANDIDATE_LIST_REQUEST:
            return {
                ...state,
                loading: action.payload,
            };

        case CLIENT_CANDIDATE_LIST_SUCCESS:
            // console.log(action.payload)
            return {
                ...state,
                result: action.payload.data,
                loading: action.payload,
            };

        case CLIENT_CANDIDATE_LIST_FAIL:
            return {
                ...state,
                error: action.error,
                loading: action.payload,
                msg: action.msg,
            };

        default:
            return state;
    }
};

export default ClientCandidateListReducer;